import axios from 'axios';

export const $httpRxNorm = axios.create({
    baseURL: import.meta.env.VITE_RXNORM_URL,
    headers: {
        get: { Accept: 'application/json' },
    },
    auth: {
        username: import.meta.env.VITE_RXNORM_USERNAME,
        password: import.meta.env.VITE_RXNORM_PASSWORD,
    },
});

export async function getMedByName(medName) {
    let response = await $httpRxNorm.post('/fhir/ValueSet/$expand', {
        resourceType: 'Parameters',
        parameter: [
            {
                name: 'valueSet',
                resource: {
                    resourceType: 'ValueSet',
                    compose: {
                        include: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                filter: [{ property: 'tty', op: 'in', value: 'IN,PIN,MIN,BN' }],
                            },
                        ],
                    },
                },
            },
            { name: 'count', valueInteger: '100' },
            { name: 'filter', valueString: medName },
        ],
    });
    return response?.data?.expansion?.contains;
}

/**
 * Search for clinical drug medications by name (SCD/SBD term types).
 * Returns results that include strength and dosage form, which are required
 * for ScriptSure drug codeset lookups.
 */
export async function getClinicalDrugByName(medName) {
    let response = await $httpRxNorm.post('/fhir/ValueSet/$expand', {
        resourceType: 'Parameters',
        parameter: [
            {
                name: 'valueSet',
                resource: {
                    resourceType: 'ValueSet',
                    compose: {
                        include: [
                            {
                                system: 'http://www.nlm.nih.gov/research/umls/rxnorm',
                                filter: [
                                    { property: 'tty', op: 'in', value: 'SCD,SBD' },
                                    {
                                        property: 'PRESCRIBABLE',
                                        op: '=',
                                        value: true,
                                    },
                                ],
                            },
                        ],
                    },
                },
            },
            { name: 'activeOnly', valueBoolean: true },
            { name: 'property', valueString: 'has_quantified_form' },
            { name: 'count', valueInteger: '100' },
            { name: 'filter', valueString: medName },
        ],
    });
    const results = response?.data?.expansion?.contains;
    if (!results) return results;
    return results.filter((concept) => !concept.extension?.some((ext) => ext.extension?.some((inner) => inner.url === 'code' && inner.valueCode === 'has_quantified_form')));
}

export async function getIcd10CodeSystemByName(code) {
    let response = await $httpRxNorm.post('/fhir/ValueSet/$expand', {
        resourceType: 'Parameters',
        parameter: [
            {
                name: 'valueSet',
                resource: {
                    resourceType: 'ValueSet',
                    compose: {
                        include: [
                            {
                                system: 'http://hl7.org/fhir/sid/icd-10-cm',
                            },
                        ],
                    },
                },
            },
            { name: 'count', valueInteger: '100' },
            { name: 'filter', valueString: code },
        ],
    });
    return response;
}
